<input (change)="selectAll()" [checked]="isChecked" [class.indeterminate-style]="this.isIndeterminate"
       [class.some-selected]="this.isIndeterminate" [indeterminate]="this.isIndeterminate" class="select-header-checkbox" type="checkbox">
